import {
	CreateDrawerFormProps,
	FormDrawerContentProps,
	I18nFormDrawer,
	I18nFormDrawerContent,
	I18nFormFetchDrawer,
	I18nTextField,
	UpdateDrawerFormProps,
	useDynamicConfig,
	validateEachLanguage,
} from "@dgs/core";
import { FormikErrors } from "formik";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { categoryService } from "../shared/api";
import { CategoryFormValues, CategoryTranslationEntry, CategoryUpdateResource } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: CategoryFormValues) => ({
		...validateEachLanguage(values.translations, (_, value) => {
			const errors: FormikErrors<CategoryTranslationEntry> = {};
			if (!value.name) {
				errors.name = t("Required field");
			}

			return errors;
		}),
	});
};

const emptyTranslation = { name: "" };

const CategoryFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<I18nFormDrawerContent {...props} emptyTranslation={emptyTranslation}>
			<I18nTextField name="name" label={t("Name")} required />
		</I18nFormDrawerContent>
	);
};

export const CategoryCreateDrawer: FC<CreateDrawerFormProps<CategoryFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const { languageSettings } = useDynamicConfig();
	const initialValues: CategoryFormValues = useMemo(
		() => ({
			translations: [{ locale: languageSettings.fallback, ...emptyTranslation }],
		}),
		[languageSettings.fallback],
	);

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Edit category")}
			validate={validate}
			renderForm={(props) => <CategoryFormDrawerContent {...props} />}
		/>
	);
};

export const CategoryUpdateDrawer: FC<UpdateDrawerFormProps<CategoryUpdateResource>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<I18nFormFetchDrawer
			{...props}
			title={t("Edit category")}
			queryFn={() => categoryService.show(props.id).then((x) => x.data.data)}
			queryKey={categoryService.showKey(props.id)}
			validate={validate}
			renderSuccess={(props) => <CategoryFormDrawerContent {...props} />}
		/>
	);
};
